import React from 'react';
import { Box, Button, Card, CardContent,  getLinkUtilityClass,  Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // import navigate hook
import { CustomWidthTooltip } from '../utils/customWidthToolTipUtil';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const SystemCard = ({ title, authorized, rogue, buttonText, direct, toolTip }) => {
  const navigate = useNavigate();
  const total = authorized + rogue;

  const minWidth = 150;
  const maxWidth = 250;

  const getWidth = (value) => {
    const proportion = value / total;
    const calculatedWidth = proportion * 300;
    return Math.max(minWidth, Math.min(maxWidth, calculatedWidth));
  };

  const handleClick = () => {
    if (direct) {
      navigate(direct);
    }
  }

  const getHrefLink = (filterType) => {
    const hrefLink = `/${title.toLowerCase()}/${filterType}`;
    return hrefLink;
  }

  return (
    <Card sx={{ minWidth: 256, maxWidth: 400, backgroundColor: 'transparent' }}>
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h5" sx={{ color: 'white', mb: 2, fontWeight: 'bold' }}>
          {title}
          <CustomWidthTooltip title={ toolTip } placement="top" dynamicWidth="550px" dyanmicHeight="25px" showPhen='true'>
              <HelpOutlineIcon sx={{ '&:hover': { cursor: 'pointer' }, ml: 2 }}/>
          </CustomWidthTooltip>
        </Typography>

        {/* Category Labels */}
        <Box sx={{ display: 'flex', borderRadius: '4px 4px 0 0', overflow: 'hidden' }}>
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `${getWidth(authorized)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            Authorized
          </Box> 
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `${getWidth(rogue)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            Rogue
          </Box>
        </Box>

        {/* Value Bars */}
        <Box sx={{ display: 'flex', height: 50, borderRadius: '0 0 4px 4px', overflow: 'hidden' }}>
          <Box
            variant="contained" 
            size="small"
            component="a"
            href={getHrefLink(`authorized`)}
            underline="none"
            sx={{
              backgroundColor: '#4caf50',
              width: `${getWidth(authorized)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              borderTop: '1px solid white',
              borderBottom: '1px solid white',
            }}
          >
            {authorized}
          </Box>
          <Box
            variant="contained" 
            size="small"
            component="a"
            href={getHrefLink(`rogue`)}
            underline="none"
            sx={{
              backgroundColor: '#f44336',
              width: `${getWidth(rogue)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              borderTop: '1px solid white',
              borderBottom: '1px solid white',
            }}
          >
            {rogue}
          </Box>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Button 
            variant="contained" 
            size="small"
            onClick={handleClick}
            sx={{ 
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
              px: 0.6,
              py: 0,
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '0.7rem',
            }}
          >
            {buttonText}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SystemCard;
